import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class DashboardService {
  fakeCall$(): Observable<string[]> {
    return of(['You are using Optima 1.1.6 (Enhanced Graphs) 📈']);
  }
}
